import { Decorative } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import styled from "styled-components";

export const NetTermsCard = styled(Column)`
  align-self: center;
  opacity: 0;
  animation: slideInFadeIn 0.5s ease-in-out forwards;
  animation-delay: 0.9s;
  background-color: ${Decorative.tint.orange};
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  padding: ${getSpacing("3x")};
  width: 100%;
  max-width: 360px;

  @keyframes slideInFadeIn {
    0% {
      transform: translateY(16px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
`;
